import React, { useEffect, useState } from "react";
import ProfileHeader from "../../../components/profile-header";
import { Container, Row } from "react-bootstrap";
import profilebg8 from "../../../assets/images/page-img/profile-bg8.jpg";
import { useParams } from "react-router-dom";
import AXIOSCONFIGMETHOD from "../../../components/apiCall/axiosConfig";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";
import { Oval } from "react-loader-spinner";

export default function Post_Feedback() {
    const { school_code } = useParams();

    const [formData, setFormData] = useState({
        student_id: localStorage.getItem("userId"),
        student_name: localStorage.getItem("username"),
        school_code: school_code,
    });

    const [loading, setLoading] = useState(false);
    const [ques, setQues] = useState([]);

    // ✅ Fetch Questions
    const getQues = async () => {
        try {
            setLoading(true);
            const resp = await AXIOSCONFIGMETHOD(
                "POST",
                webServiceUrl.post_feedback_ques,
            );

            setQues(resp?.data?.data || []);
        } catch (err) {
            console.error(err);
            toast.error("Failed to load questions");
        } finally {
            setTimeout(() => setLoading(false), 800);
        }
    };

    useEffect(() => {
        getQues();
    }, []);

    // ✅ Handle Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ✅ Submit Handler (IMPORTANT)
    const handleSubmit = async (e) => {
        e.preventDefault();

const finalPayload = {
  student_id: formData.student_id,
  student_name: formData.student_name,
  school_code: formData.school_code,
};

// 🔥 Convert q_0 → q1, q_1 → q2 ...
Object.keys(formData)
  .filter((key) => key.startsWith("q_"))
  .forEach((key, index) => {
    finalPayload[`q${index + 1}`] = formData[key];
  });

console.log("FINAL PAYLOAD 👉", finalPayload);

        try {
            const resp = await AXIOSCONFIGMETHOD(
                "POST",
                webServiceUrl.post_feedback_form,
                finalPayload,
            );

            if (resp?.success || resp?.data?.success) {
                toast.success(
                    resp?.message ||
                        resp?.data?.message ||
                        "Submitted successfully",
                );
            } else {
                toast.error(resp?.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error("Submission failed. Please try again.");
        }
    };

    // ✅ Loader
    if (loading) {
        return (
            <div
                className="d-flex justify-content-center"
                style={{ height: "85vh", paddingTop: "15vh" }}
            >
                <Oval height="50" width="50" color="#4fa94d" />
            </div>
        );
    }

//     const questions = [
//     { "id": 1, "question": "How was the overall quality of the sessions? (Day-1)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 2, "question": "How was the overall quality of the sessions? (Day-2)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 3, "question": "How was the overall quality of the sessions? (Day-3)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 4, "question": "How was the overall quality of the sessions? (Day-4)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 5, "question": "How was the overall quality of the sessions? (Day-5)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 6, "question": "How was the overall quality of the sessions? (Day-6)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },

//     { "id": 7, "question": "How were the facilities? (Room Quality)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 8, "question": "How were the facilities? (Food & Tea)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 9, "question": "How were the facilities? (Classroom Group)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },
//     { "id": 10, "question": "How were the facilities? (Overall Management)", "opt_1": "Poor", "opt_2": "Fair", "opt_3": "Good", "opt_4": "Excellent", "school_id": null },

//     { "id": 11, "question": "What was the best part of the training?", "opt_1": null, "opt_2": null, "opt_3": null, "opt_4": null, "school_id": null },
//     { "id": 12, "question": "What improvements would you suggest?", "opt_1": null, "opt_2": null, "opt_3": null, "opt_4": null, "school_id": null },

//     { "id": 13, "question": "Will this training help you perform your work better?", "opt_1": "Yes", "opt_2": "No", "opt_3": "Maybe", "opt_4": null, "school_id": null },
//     { "id": 14, "question": "After attending this training, did you find new solutions to the challenges you face at work?", "opt_1": "Yes", "opt_2": "No", "opt_3": "Maybe", "opt_4": null, "school_id": null },
//     { "id": 15, "question": "Would you encourage others to attend this kind of training?", "opt_1": "Yes", "opt_2": "No", "opt_3": "Maybe", "opt_4": null, "school_id": null },
//     { "id": 16, "question": "Do you want to attend a more advanced training in the future?", "opt_1": "Yes", "opt_2": "No", "opt_3": "Maybe", "opt_4": null, "school_id": null },

//     { "id": 17, "question": "How relevant and useful were the sessions on effective use of AI and emerging technologies in education for your teaching practice?", "opt_1": "Not relevant", "opt_2": "Somewhat relevant", "opt_3": "Relevant", "opt_4": "Highly relevant", "school_id": null },

//     { "id": 18, "question": "Do you believe more training sessions on AI, emerging technologies, and drones should be organized regularly for UBTE faculties?", "opt_1": "No, not needed", "opt_2": "Maybe occasionally", "opt_3": "Yes, periodically", "opt_4": "Yes, frequently/regularly", "school_id": null },

//     { "id": 19, "question": "Would you support making regular AI and emerging technology training (with hands-on components) a standard part of professional development for teachers?", "opt_1": "Yes", "opt_2": "No", "opt_3": "Maybe", "opt_4": null, "school_id": null },

//     { "id": 20, "question": "How valuable was the drone theory and hands-on session for your understanding and classroom application?", "opt_1": "Not valuable", "opt_2": "Somewhat valuable", "opt_3": "Valuable", "opt_4": "Extremely valuable", "school_id": null },

//     { "id": 21, "question": "Do you think organizing competition-based learning activities (such as hackathons, robotics championships) would benefit your students' engagement and skill development?", "opt_1": "Not at all", "opt_2": "Somewhat", "opt_3": "Yes, it would help", "opt_4": "Yes, it is highly needed", "school_id": null },

//     { "id": 22, "question": "How can we better integrate competition-based or hands-on learning in future teacher training programs?", "opt_1": null, "opt_2": null, "opt_3": null, "opt_4": null, "school_id": null },

//     { "id": 23, "question": "What specific topics on AI, emerging technologies, or drones would you like to see covered in future trainings?", "opt_1": null, "opt_2": null, "opt_3": null, "opt_4": null, "school_id": null },

//     { "id": 24, "question": "One thing I would like to see more of in future programs is.", "opt_1": null, "opt_2": null, "opt_3": null, "opt_4": null, "school_id": null }
//   ]



    return (
        <>
            <ProfileHeader img={profilebg8} />
            <ToastContainer />

            <div className="content-inner pt-4">
                <Container>
                    <Row>
                        <form onSubmit={handleSubmit} className="container p-4">
                            <div className="row">
                                {/* {questions.map((item, index) => { */}
                                {ques.map((item, index) => {
                                    const options = [
                                        item?.opt_1,
                                        item?.opt_2,
                                        item?.opt_3,
                                        item?.opt_4,
                                    ].filter(Boolean);

                                    return (
                                        <div
                                            key={index}
                                            className="col-md-6 mb-4"
                                        >
                                            <fieldset className="mb-4">
                                                <legend className="fw-semibold mb-3">
                                                    {index + 1}. {item.question}
                                                </legend>
                                                {options.length > 0 ? (
                                                    options.map((option) => (
                                                        <div
                                                            className="form-check mb-2"
                                                            key={option}
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`q_${index}`} // ✅ FIXED
                                                                value={option}
                                                                checked={
                                                                    formData[
                                                                        `q_${index}`
                                                                    ] === option
                                                                } // ✅ FIXED
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                required
                                                            />
                                                            <label className="form-check-label ms-2">
                                                                {option}
                                                            </label>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <textarea
                                                        className="form-control"
                                                        name={`q_${index}`} // ✅ FIXED
                                                        placeholder="Enter your answer..."
                                                        value={
                                                            formData[
                                                                `q_${index}`
                                                            ] || ""
                                                        }
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                )}
                                            </fieldset>
                                        </div>
                                    );
                                })}
                            </div>

                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </form>
                    </Row>
                </Container>
            </div>
        </>
    );
}

// import React, { useEffect, useState } from "react";
// import ProfileHeader from "../../../components/profile-header";
// import { Container, Row } from "react-bootstrap";
// import profilebg8 from "../../../assets/images/page-img/profile-bg8.jpg";
// import { useParams } from "react-router-dom";
// import AXIOSCONFIGMETHOD from "../../../components/apiCall/axiosConfig";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
// import { toast, ToastContainer } from "react-toastify";
// import { Oval } from "react-loader-spinner";

// export default function Post_Feedback() {
//   const users = JSON.parse(localStorage.getItem("users") || "[]"); // defaults to empty array
//   const { school_code } = useParams()
//   // console.log(school_code);
//   const [formData, setFormData] = useState({
//     student_id: localStorage.getItem("userId"),
//     student_name: localStorage.getItem("username"),
//     school_code: school_code
//   });
//   const [loading, setLoading] = useState(false);
//   const [ques, setQues] = useState([])

//   const getQues = async () => {
//     try {
//       setLoading(true);
//       const resp = await AXIOSCONFIGMETHOD("POST", webServiceUrl.post_feedback_ques)
//       console.log(resp.data)
//       setQues(resp?.data?.data)
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setTimeout(() => setLoading(false), 1500);
//     }
//   }

//   useEffect(() => {
//     getQues()
//   }, [])

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // console.log(formData);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("Submitted data:", formData);

//     try {
//       const resp = await AXIOSCONFIGMETHOD("POST", webServiceUrl.post_feedback_form, formData);

//       if (resp?.success) {
//         toast.success(resp?.message || resp?.data?.message || "Submitted successfully");
//       } else {
//         toast.error(resp?.message || "Something went wrong");
//       }
//     } catch (error) {
//       console.error("Submit error:", error);
//       toast.error(error?.message || "Submission failed. Please try again.");
//     }
//   };

//   if (loading) {
//     return (
//       <>
//         <div
//           className="d-flex justify-content-center "
//           style={{ height: "85vh", paddingTop: "15vh" }}
//         >
//           <Oval
//             height="50"
//             width="50"
//             color="#4fa94d"
//             secondaryColor="#4fa94d"
//           />
//         </div>
//       </>
//     );
//   }

//    // ✅ Static Questions (No API)
//   const questions = [
//     { question: "Day 1: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 2: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 3: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 4: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 5: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },

//     { question: "Room Quality", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Food & Tea", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Classroom Setup", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Overall Management", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },

//     { question: "Will this training help you do your work better?", opt_1: "1", opt_2: "2", opt_3: "3", opt_4: "4" },

//     { question: "After attending this training, did you find new solutions for the problems you face at work?", opt_1: "Yes", opt_2: "No", opt_3: "Maybe", opt_4: null },

//     { question: "Would you encourage other officers to attend this program?", opt_1: "1", opt_2: "2", opt_3: "3", opt_4: "4" },

//     { question: "Do you want to attend a more advanced/specified training next time?", opt_1: "Yes", opt_2: "No", opt_3: "Maybe", opt_4: null },

//     { question: "What was the best part of the training?", opt_1: null, opt_2: null, opt_3: null, opt_4: null },

//     { question: "How can we improve?", opt_1: null, opt_2: null, opt_3: null, opt_4: null }
//   ];

//   return (
//     <>
//       <ProfileHeader img={profilebg8} />
//       <ToastContainer />
//       <div
//         id="content-page"
//         className="content-inner store-details upcoming-card pt-4 mt-0"
//       >
//         <Container>
//           <Row>
//             <form onSubmit={handleSubmit} className="container p-4">
//               <div className="row">
//                 {/* Left Column (3 questions) */}
//                 <div className="row">
//                   {ques.map((item, index) => (
//                     <div key={index} className="col-md-6 mb-4">
//                       <fieldset className="mb-4">
//                         <legend className="fw-semibold mb-3">
//                           {index + 1}. {item?.question}
//                         </legend>
//                         {[item?.opt_1, item?.opt_2, item?.opt_3, item?.opt_4].map((option) => (
//                           <div className="form-check mb-2" key={option}>
//                             <input
//                               className="form-check-input"
//                               type="radio"
//                               name={`q${index + 1}`}
//                               id={`q${index + 1}-${option}`}
//                               value={option}
//                               checked={formData[`q${index + 1}`] === option}
//                               onChange={handleChange}
//                               required
//                             />
//                             <label className="form-check-label" htmlFor={`q${index + 1}-${option}`}>
//                               {option}
//                             </label>
//                           </div>
//                         ))}
//                       </fieldset>
//                     </div>
//                   ))}
//                 </div>

//               </div>

//               <button
//                 type="submit"
//                 className="btn btn-primary"
//               >
//                 Submit
//               </button>
//             </form>

//           </Row></Container></div>
//     </>
//   );
// }

// import React, { useState } from "react";
// import ProfileHeader from "../../../components/profile-header";
// import { Container, Row } from "react-bootstrap";
// import profilebg8 from "../../../assets/images/page-img/profile-bg8.jpg";
// import { useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";

// export default function Post_Feedback() {
//   const { school_code } = useParams();

//   // ✅ Static Questions (No API)
//   const questions = [
//     { question: "Day 1: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 2: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 3: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 4: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Day 5: How was the quality of these sessions?", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },

//     { question: "Room Quality", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Food & Tea", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Classroom Setup", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },
//     { question: "Overall Management", opt_1: "Poor", opt_2: "Fair", opt_3: "Good", opt_4: "Excellent" },

//     { question: "Will this training help you do your work better?", opt_1: "1", opt_2: "2", opt_3: "3", opt_4: "4" },

//     { question: "After attending this training, did you find new solutions for the problems you face at work?", opt_1: "Yes", opt_2: "No", opt_3: "Maybe", opt_4: null },

//     { question: "Would you encourage other officers to attend this program?", opt_1: "1", opt_2: "2", opt_3: "3", opt_4: "4" },

//     { question: "Do you want to attend a more advanced/specified training next time?", opt_1: "Yes", opt_2: "No", opt_3: "Maybe", opt_4: null },

//     { question: "What was the best part of the training?", opt_1: null, opt_2: null, opt_3: null, opt_4: null },

//     { question: "How can we improve?", opt_1: null, opt_2: null, opt_3: null, opt_4: null }
//   ];

//   const [formData, setFormData] = useState({
//     student_id: localStorage.getItem("userId"),
//     student_name: localStorage.getItem("username"),
//     school_code: school_code
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     console.log("Submitted Data:", formData);

//     toast.success("Form submitted successfully!");
//   };

//   return (
//     <>
//       <ProfileHeader img={profilebg8} />
//       <ToastContainer />

//       <div className="content-inner pt-4">
//         <Container>
//           <Row>
//             <form onSubmit={handleSubmit} className="container p-4">
//               <div className="row">
//                 {questions.map((item, index) => {
//                   const options = [
//                     item.opt_1,
//                     item.opt_2,
//                     item.opt_3,
//                     item.opt_4
//                   ].filter(Boolean);

//                   return (
//                     <div key={index} className="col-md-6 mb-4">
//                       <fieldset className="mb-4">
//                         <legend className="fw-semibold mb-3">
//                           {index + 1}. {item.question}
//                         </legend>

//                         {/* Radio Questions */}
//                         {options.length > 0 ? (
//                           options.map((option) => (
//                             <div className="form-check mb-2" key={option}>
//                               <input
//                                 className="form-check-input"
//                                 type="radio"
//                                 name={`q${index + 1}`}
//                                 id={`q${index + 1}-${option}`}
//                                 value={option}
//                                 checked={formData[`q${index + 1}`] === option}
//                                 onChange={handleChange}
//                                 required
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor={`q${index + 1}-${option}`}
//                               >
//                                 {option}
//                               </label>
//                             </div>
//                           ))
//                         ) : (
//                           /* Text Questions */
//                           <textarea
//                             className="form-control"
//                             name={`q${index + 1}`}
//                             placeholder="Enter your answer..."
//                             value={formData[`q${index + 1}`] || ""}
//                             onChange={handleChange}
//                             required
//                           />
//                         )}
//                       </fieldset>
//                     </div>
//                   );
//                 })}
//               </div>

//               <button type="submit" className="btn btn-primary">
//                 Submit
//               </button>
//             </form>
//           </Row>
//         </Container>
//       </div>
//     </>
//   );
// }

{
    /* Right Column (2 questions) */
}
{
    /* <div className="col-md-6 mb-4">
      <fieldset className="mb-4">
        <legend className="fw-semibold mb-3">
          4. How useful were the hands-on activities and practical sessions (e.g., coding exercises, AI demos, lab visits)?
        </legend>
        {["Very Useful", "Useful", "Neutral", "Not Useful"].map((option) => (
          <div className="form-check mb-2" key={option}>
            <input
              className="form-check-input"
              type="radio"
              name="q4"
              id={`q4-${option}`}
              value={option}
              checked={formData.q4 === option}
              onChange={handleChange}
              required
            />
            <label className="form-check-label" htmlFor={`q4-${option}`}>
              {option}
            </label>
          </div>
        ))}
      </fieldset>

      <fieldset className="mb-4">
        <legend className="fw-semibold mb-3">
          5. To what extent did the training encourage collaboration and active participation?
        </legend>
        {[
          "To a Great Extent",
          "To Some Extent",
          "Very Little",
          "Not at All",
        ].map((option) => (
          <div className="form-check mb-2" key={option}>
            <input
              className="form-check-input"
              type="radio"
              name="q5"
              id={`q5-${option}`}
              value={option}
              checked={formData.q5 === option}
              onChange={handleChange}
              required
            />
            <label className="form-check-label" htmlFor={`q5-${option}`}>
              {option}
            </label>
          </div>
        ))}
      </fieldset>
    </div> */
}
